import classNames from 'classnames'
import { useFormikContext } from 'formik'

import { Content } from '../../../Modal'
import { useFormValidationErrorsNotification } from '../../Form.hooks'
import { FormBody } from '../../FormBody'
import { FormInlineNotifications } from '../../FormInlineNotifications'

import * as styles from './FormModalBody.module.css'

function FormModalBody({
  Actions,
  Fields,
  actionsProps,
  contentClassName, // #TODO to contentProps
  contentProps,
  formFieldsProps,
  notifications,
  submitButtonText = 'Modal.SaveBtnKey',
  submitQaName,
  validationErrorsNotificationProps,
  withNotifications,
  onCancel,
  onSubmit,
}) {
  const { dirty, isSubmitting, values } = useFormikContext()

  useFormValidationErrorsNotification(validationErrorsNotificationProps)

  function handleCancel() {
    return onCancel({ dirty, values })
  }

  function handleSubmit(e) {
    onSubmit?.(e)
  }

  return (
    <FormBody
      Actions={Actions}
      actionsProps={{
        ...actionsProps,
        ButtonAdd: false,
        ButtonClear: false,
        UploadComponent: false,
        cancelProps: {
          ...actionsProps?.cancelProps,
          height: 40,
          onClick: handleCancel,
        },
        className: classNames(styles.actions, actionsProps?.className),
        isSubmitting,
        submitProps: {
          ...actionsProps?.submitProps,
          height: 40,
          isLoading: isSubmitting,
          qaName: submitQaName,
          title: submitButtonText,
          onClick: handleSubmit,
        },
      }}
    >
      <Content {...contentProps} className={contentClassName}>
        {withNotifications ? (
          <FormInlineNotifications notifications={notifications} />
        ) : null}
        <Fields {...formFieldsProps} />
      </Content>
    </FormBody>
  )
}

export default FormModalBody
